import { useTranslation } from 'react-i18next';
import styles from './Steper.module.css';
import { useEffect } from 'react';

function Steper({ activeStep, setActiveSteps, validateStep }) {
    const { t } = useTranslation();

    const stepsData = [
        { step: 1, name: t("QualificationAndSkills.steper.steps.0.name") },
        { step: 2, name: t("QualificationAndSkills.steper.steps.1.name") },
        { step: 3, name: t("QualificationAndSkills.steper.steps.2.name") },
        { step: 4, name: t("QualificationAndSkills.steper.steps.3.name") },
        { step: 5, name: t("QualificationAndSkills.steper.steps.4.name") }
    ];

    const handleStepClick = (step) => {
        // Just call the provided setActiveSteps function
        // It will handle validation and complex logic in PostJob/EditJob
        if (step !== activeStep) {
            setActiveSteps(step);
        }
    };
    useEffect(() => {
        return () => {
            setActiveSteps(1);
        }
    }, [])

    return (
        <div className={styles.steper}>
            {stepsData.map((item, index) => (
                <div className={styles.wrapper} key={index.toString()}>
                    {index < 4 && (
                        <div
                            className={styles.hrLine}
                            style={{
                                backgroundColor: item.step < activeStep ? "#0464B2" : "#C5C5C5"
                            }}
                        ></div>
                    )}
                    <div
                        onClick={() => handleStepClick(item.step)}
                        className={`${styles.circle} ${styles.clickable}`}
                        style={{ backgroundColor: item.step <= activeStep ? "#0464B2" : "#C5C5C5" }}
                    >
                        {item.step}
                    </div>
                    <p
                        onClick={() => handleStepClick(item.step)}
                        className={`${styles.tabName} ${styles.clickable}`}
                        style={{ color: item.step <= activeStep ? "#0464B2" : "#C5C5C5" }}
                    >
                        {item.name}
                    </p>
                </div>
            ))}
        </div>
    );
}

export default Steper;
